<template>
    <div class="left-menu" id='left-menu'>
        <div class="menu-box">
            <el-menu class="yun-menu-aside-box" :default-active="route">
                <el-menu-item index="latest">
                    <router-link tag="div" class="menu-item-wraper" :to="`${baseUrl}/latest`">
                        <div class="menu-icon-box">
                            <i class="components-icons normal-icon components-icons-latest"></i>
                            <i class="components-icons hover-icon components-icons-latest-selected"><span class="path1"></span></i>
                        </div>
                        <span class="menu-text nowrap" v-cloak :title="$t('Recent')">{{$t('Recent')}}</span>
                    </router-link>
                </el-menu-item>
                <el-menu-item index="starred">
                    <router-link tag="div" class="menu-item-wraper" :to="`${baseUrl}/starred`">
                        <div class="menu-icon-box">
                            <i class="components-icons normal-icon components-icons-star"></i>
                            <i class="components-icons hover-icon components-icons-star-selected"><span class="path1"></span></i>
                        </div>
                        <span class="menu-text nowrap" v-cloak :title="$t('Starred')">{{$t('Starred')}}</span>
                    </router-link>
                </el-menu-item>
                <el-menu-item index="all">
                    <router-link tag="div" class="menu-item-wraper" :to="`${!baseUrl ? '/' : baseUrl}`">
                        <div class="menu-icon-box">
                            <i class="components-icons normal-icon components-icons-all-s"></i>
                            <i class="components-icons hover-icon components-icons-all-s-selected"><span class="path1"></span></i>
                        </div>
                        <span class="menu-text nowrap" v-cloak :title="$t('Mycloud')">{{$t('Mycloud')}}</span>
                    </router-link>
                </el-menu-item>
                <el-menu-item index="received">
                    <router-link tag="div" class="menu-item-wraper" :to="`${baseUrl}/received`">
                        <div class="menu-icon-box">
                            <i class="components-icons normal-icon components-icons-share"></i>
                            <i class="components-icons hover-icon components-icons-share-selected"><span class="path1"></span></i>
                        </div>
                        <span class="menu-text nowrap" v-cloak :title="$t('ShareMenu')">{{$t('ShareMenu')}}</span>
                    </router-link>
                </el-menu-item>
                <el-menu-item index="teams">
                    <router-link tag="div" class="menu-item-wraper" :to="`${baseUrl}/team`">
                        <div class="menu-icon-box">
                            <i class="components-icons normal-icon components-icons-team"></i>
                            <i class="components-icons hover-icon components-icons-team-selected"><span class="path1"></span></i>
                        </div>
                        <span class="menu-text nowrap" v-cloak :title="$t('Teams')">{{$t('Teams')}}</span>
                    </router-link>
                </el-menu-item>
            </el-menu>
            <router-link :to="`${baseUrl}/trash`">
                <div class="menu-trash">
                <div class="trash-content">
                    <div class="trash-icon">
                        <i class="el-icon-delete"></i>
                    </div>
                    <span class="trash-text" v-cloak :title="$t('Trash')">{{$t('Trash')}}</span>
                </div>
            </div>
            </router-link>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
    name: 'asideMenu',
    computed: {

    },


    data: function () {
        return {
        }
    },
    computed:{
        ...mapState([
            'baseUrl',
            'route'
        ])
    },
    created(){

    },
    beforeRouteUpdate: function (to, from, next) {

    },

    methods: {

    },

    mounted () {

    }
}
</script>

<style>
.menu-box .yun-menu-aside-box {
    border: none;
    padding-top: 24px;
}
.yun-menu-aside-box .components-icons{
    font-size: 16px;
    vertical-align: middle;
}
.left-menu{
    flex: 0 0 211px;
    position: relative;
    border-right: 1px solid #e7e9eb;
}
.menu-box{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0 15px;
}
.menu-box .el-menu-item{
    padding: 0!important;
    height: 42px;
    line-height: 42px;
    color: #626b84;
    cursor: pointer;
    font-size: 0;
}
.menu-text{
    font-size: 12px;
    display: inline-block;
    width: 146px;
}
.yun-menu-aside-box.el-menu .el-menu-item.is-active{
    background: #f7f9fc;
    color: #2e68f8;
}
.menu-item-wraper{
    padding-left: 9px;
}
.el-menu-item .hover-icon{
    display: none;
}
.el-menu-item.is-active .normal-icon{
    display: none;
}
.el-menu-item.is-active .hover-icon{
    display: inline-block;
    color: #2e68f8;
}
.menu-icon-box{
    display: inline-block;
    width: 26px;
}
.yun-menu-aside-box.el-menu .el-menu-item:hover{
    background: #fafcff;
}
.menu-trash{
    height: 42px;
    line-height: 42px;
    color: #6c748a;
    border-top: 1px solid #e7e9eb;
    padding-left: 24px;
    margin-left: -15px;
    margin-right: -15px;
    position: fixed;
    bottom: 0;
    width: 187px;
}
.trash-content{
    display: flex;
    align-items: center;
}
.trash-icon{
    line-height: 42px;
    display: inline-block;
    width: 26px;
    font-size: 16px;
}
.trash-text{
    line-height: 42px;
    display: inline-block;
    font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/AsideMenu.vue